    export interface IContactMechanism {
        contactMechanismId: number;
        customerId: number;
        isPrimary: boolean;
        value: string;
        createDate: Date;
        createBy: string;
        modifyBy: string;
        modifyDate: Date;
    }

    export class ContactMechanism implements IContactMechanism {
        contactMechanismId: number;
        customerId: number;
        isPrimary: boolean;
        value: string;
        createDate: Date;
        createBy: string;
        modifyBy: string;
        modifyDate: Date;
    }